var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{attrs:{"id":"job-audio","controls":"","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm.file}}),_vm._v(" Your browser does not support the audio element. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }